import { z } from 'zod'

import {
  ExternalTriggerItemSchema,
  FlowItemSchema,
  GeneralItemSchema,
  GrowthToolItemSchema,
  IntegrationItemSchema,
  IntentItemSchema,
  KeywordItemSchema,
  SequenceItemSchema,
  TemplateInstallationsItemSchema,
  TriggerItemSchema,
} from 'shared/api/common/schemas/templates/modelItems'

export const ModelsSchema = z.object({
  sequences: z.array(SequenceItemSchema),
  growth_tools: z.array(GrowthToolItemSchema),
  keywords: z.array(KeywordItemSchema),
  intents: z.array(IntentItemSchema),
  flows: z.array(FlowItemSchema),
  generals: z.array(GeneralItemSchema),
  integrations: z.array(IntegrationItemSchema),
  triggers: z.array(TriggerItemSchema),
  external_triggers: z.array(ExternalTriggerItemSchema),
  template_installations: z.array(TemplateInstallationsItemSchema),
})

export const FilterSection = 'template_installations'
const ModelsKeysSchema = ModelsSchema.omit({ [FilterSection]: true }).keyof()
export type ModelsKeys = z.infer<typeof ModelsKeysSchema>
